var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFA726",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 28.75H29.75",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2472 32.1875C46.2472 32.0816 46.25 31.4546 46.2472 31.4106C46.1977 30.7218 45.6079 30.1731 44.8654 30.1277C44.8173 30.125 44.7609 30.125 44.6454 30.125H41.0676C38.6133 30.125 36.625 31.9716 36.625 34.25C36.625 36.5284 38.6146 38.375 41.0662 38.375H44.6454C44.7609 38.375 44.8173 38.375 44.8654 38.3722C45.6079 38.3269 46.1991 37.7783 46.2472 37.0894C46.25 37.0454 46.25 36.4184 46.25 36.3125",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 35.625C41.5094 35.625 42.125 35.0094 42.125 34.25C42.125 33.4906 41.5094 32.875 40.75 32.875C39.9906 32.875 39.375 33.4906 39.375 34.25C39.375 35.0094 39.9906 35.625 40.75 35.625Z",
    fill: "#FFA726"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 45.2502H33.875C39.0601 45.2502 41.6534 45.2502 43.2635 43.6387C44.3759 42.5277 44.721 40.9492 44.8269 38.3752M44.8269 30.1252C44.7196 27.5512 44.3759 25.9727 43.2635 24.8617C41.6534 23.2502 39.0601 23.2502 33.875 23.2502H29.75C24.5649 23.2502 21.9716 23.2502 20.3615 24.8617C18.75 26.4719 18.75 29.0651 18.75 34.2502C18.75 39.4354 18.75 42.0286 20.3615 43.6387C21.2594 44.538 22.4625 44.9354 24.25 45.11M24.25 23.2502L29.3856 19.8444C30.1079 19.3746 30.9509 19.1245 31.8125 19.1245C32.6741 19.1245 33.5171 19.3746 34.2394 19.8444L39.375 23.2502",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.befd776a65044f14524eb00e7843fd05.svg";
export { ForwardRef as ReactComponent };